import React from 'react';
import PropTypes from 'prop-types';


const propTypes = {
  onDemand: PropTypes.bool,
  className: PropTypes.string,
};

const defaultProps = {
  onDemand: false,
  className: '',
};

const OnDemandIcon = ({ onDemand, className }) => {
  if (onDemand) {
    return (
      <div className={`iconified-font iconified-on-demand iconified-top ${className}`} />
    );
  }

  return null;
};

OnDemandIcon.propTypes = propTypes;
OnDemandIcon.defaultProps = defaultProps;
export default OnDemandIcon;
